import gql from 'graphql-tag';

export const _GET_INVOICE_DATA = gql`
	query gqlInvoices_getInvoiceInterchangeLinks($participantRef: uuid!, $invoice: uuid!) {
		invoice: risolto_invoice_document(where: { _and: [
			{ reference: {_eq: $invoice} },
			{ participant: {_eq: $participantRef} }
			]
		}) {
			reference
			actions (
				where: {
					executed_at: {_is_null: false}
				}
			){
				reference
				action_interchanges {
					reference
					interchange_by_reference {
						reference
						interchange_events {
							event_type
							event_type_count
							last_event_timestamp
							email: channel_endpoint(path: "$.email")
							postal_mail: channel_endpoint(path: "postal_mail")
						}
						channel
						direction
					}
				}
			}
			dunning_status
			recipient_by_reference {
				participant
				reference
				name
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
				}
			}
			invoice_dispute: disputes(
				where: {
					resolved_at: { _is_null: true }
				}
				order_by: {
					until: desc
				}
				limit: 1
				) {
				reference
				until
			}
			legal_entity_by_reference {
				reference
				registration_name
			}
			participant_by_reference {
				name
				reference
				logical_id
			}
			file_references: attachments
			derived_paid_at
		}
	}
`;

export const _GET_INVOICE = gql`
	query gqlInvoices_getInvoice($invoice: uuid!) {
		invoice: risolto_invoice_document(where: { reference: { _eq: $invoice } }) {
			processing_due_date
			invoice_number
			document_number
			amount_currency
			dunning_started
			earliest_dunning_time
			earliest_submission_time
			issue_date
			due_date
			reference
			payment_reference
			file_reference
			file_references
			legal_entity
			legal_entity_by_reference {
				registration_name
				reference
				participant
				address
				company_id
				company_id_type
			}
			total_amount
			open_amount
			amount_currency
			participant
			interchange_links {
				reference
				interchange_by_reference {
					interchange_events {
						event_type
						event_type_count
						last_event_timestamp
						email: channel_endpoint(path: "$.email")
						postal_mail: channel_endpoint(path: "postal_mail")
					}
					reference
					channel
					direction
				}
			}
			recipient
			recipient_by_reference {
				preferred_invoicing_channel
				legal_entity
				legal_entity_by_reference {
					reference
				}
				participant
				reference
				type
				legal_id
				legal_id_type
				address
				name
				account_id
			}
			actions: action_invoices {
				action_by_reference {
					reference
					message_code
				}
			}
			dunning_status
			total_actions: action_invoices_aggregate {
				aggregate {
					count
				}
			}
			custom_fields
			attachments
		}
	}
`;

export const _GET_INVOICES = gql`
query gqlInvoices_getInvoices(
	$limit: Int = 10
	$offset: Int = 0
	$participantRef: uuid!
	$status: [risolto_invoice_document_status_enum!]
	$orderBy: [risolto_invoice_document_order_by!]
	$searchTerm: String!
	$searchAmount_min: numeric!
	$searchAmount_max: numeric!
	$today: date!
  ) {
	total: risolto_invoice_document_aggregate(
	  where: {
		participant: { _eq: $participantRef }
		status: { _in: $status }
		_or: [
		  {
			recipient_by_reference: {
			  _or: [
				{ name: { _ilike: $searchTerm } }
				{ legal_id: { _ilike: $searchTerm } }
				{ account_id: { _ilike: $searchTerm } }
			  ]
			}
		  }
		  {
			_and: [
			  { open_amount: { _gt: $searchAmount_min } }
			  { open_amount: { _lt: $searchAmount_max } }
			]
		  }
		  {
			_and: [
			  { total_amount: { _gt: $searchAmount_min } }
			  { total_amount: { _lt: $searchAmount_max } }
			]
		  }
		  { invoice_number: { _ilike: $searchTerm } }
		  { payment_reference: { _ilike: $searchTerm } }
		]
	  }
	) {
	  aggregate {
		count
	  }
	}
	invoices: risolto_invoice_document(
	  limit: $limit
	  offset: $offset
	  order_by: $orderBy
	  where: {
		participant: { _eq: $participantRef }
		status: { _in: $status }
		_or: [
		  {
			recipient_by_reference: {
			  _or: [
				{ name: { _ilike: $searchTerm } }
				{ legal_id: { _ilike: $searchTerm } }
				{ account_id: { _ilike: $searchTerm } }
			  ]
			}
		  }
		  {
			_and: [
			  { open_amount: { _gt: $searchAmount_min } }
			  { open_amount: { _lt: $searchAmount_max } }
			]
		  }
		  {
			_and: [
			  { total_amount: { _gt: $searchAmount_min } }
			  { total_amount: { _lt: $searchAmount_max } }
			]
		  }
		  { invoice_number: { _ilike: $searchTerm } }
		  { payment_reference: { _ilike: $searchTerm } }
		]
	  }
	) {
	  total_actions: action_invoices_aggregate {
		aggregate {
		  count
		}
	  }
	  total_open_actions: action_invoices_aggregate(
		where: { invoice_by_reference: { status: { _eq: OPEN } } }
	  ) {
		aggregate {
		  count
		}
	  }
	  processing_due_date
	  invoice_number
	  open_amount
	  total_amount
	  payment_reference
	  due_date
	  file_reference
	  file_references
	  issue_date
	  status
	  recipient
	  recipient_by_reference {
		participant
		reference
		name
		account_id
		legal_entity
		legal_entity_by_reference {
		  reference
		  registration_name
		}
	  }
	  legal_entity
	  legal_entity_by_reference {
		reference
		registration_name
	  }
	  processing_due_date
	  participant
	  participant_by_reference {
		name
		reference
		logical_id
	  }
	  reference
	  amount_currency
	  invoice_dispute: disputes(
		where: { until: { _gte: $today } }
		order_by: { until: desc }
		limit: 1
	  ) {
		reference
		until
	  }
	}
  }  
`;

export const _GET_INVOICES_FOR_RECIPIENT = gql`
	query gqlInvoices_getInvoicesForRecipient(
		$limit: Int = 10
		$offset: Int = 0
		$participantRef: uuid!
		$recipient: uuid!
		$status: [risolto_invoice_document_status_enum!]
		$orderBy: [risolto_invoice_document_order_by!]
		$searchTerm: String!
		$searchAmount_min: numeric!
		$searchAmount_max: numeric!
		$today: date!
	) {
		total: risolto_invoice_document_aggregate(
			where: {
				participant: { _eq: $participantRef }
				recipient: { _eq: $recipient }
				status: { _in: $status }
				_or: [
					{ _and: [{ open_amount: { _gt: $searchAmount_min } }, { open_amount: { _lt: $searchAmount_max } }] }
					{ _and: [{ total_amount: { _gt: $searchAmount_min } }, { total_amount: { _lt: $searchAmount_max } }] }
					{ invoice_number: { _ilike: $searchTerm } }
					{ payment_reference: { _ilike: $searchTerm } }
				]
			}
		) {
			aggregate {
				count
			}
		}
		invoices: risolto_invoice_document(
			limit: $limit
			offset: $offset
			order_by: $orderBy
			where: {
				participant: { _eq: $participantRef }
				recipient: { _eq: $recipient }
				status: { _in: $status }
				_or: [
					{ _and: [{ open_amount: { _gt: $searchAmount_min } }, { open_amount: { _lt: $searchAmount_max } }] }
					{ _and: [{ total_amount: { _gt: $searchAmount_min } }, { total_amount: { _lt: $searchAmount_max } }] }
					{ invoice_number: { _ilike: $searchTerm } }
					{ payment_reference: { _ilike: $searchTerm } }
				]
			}
		) {
			processing_due_date
			invoice_number
			open_amount
			total_amount
			payment_reference
			due_date
			file_reference
			file_references
			issue_date
			status
			recipient
			recipient_by_reference {
				participant
				reference
				name
				account_id
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
				}
			}
			legal_entity
			legal_entity_by_reference {
				reference
				registration_name
			}
			processing_due_date
			participant
			participant_by_reference {
				name
				reference
				logical_id
			}
			reference
			amount_currency
			invoice_dispute: disputes(
				where: {
					until: { _gte: $today }
					resolved_at: { _is_null: true }
				}
				order_by: {
					until: desc
				}
				limit: 1
				) {
				reference
				until
			}
		}
	}
`;

export const _FIND_INVOICES = gql`
	query gqlInvoices_findInvoices($searchTerm: String, $amount: numeric) {
		total: risolto_invoice_document_aggregate(
			where: {
				_or: [
					{ invoice_number: { _ilike: $searchTerm } }
					{ payment_reference: { _ilike: $searchTerm } }
					{ total_amount: { _eq: $amount } }
					{ open_amount: { _eq: $amount } }
					{ recipient_by_reference: { bank_accounts: { account_number: { _ilike: $searchTerm } } } }
					{ recipient_by_reference: { name: { _ilike: $searchTerm } } }
					{ recipient_by_reference: { account_id: { _ilike: $searchTerm } } }
				]
			}
		) {
			aggregate {
				count
			}
		}
		invoices: risolto_invoice_document(
			where: {
				_or: [
					{ invoice_number: { _ilike: $searchTerm } }
					{ payment_reference: { _ilike: $searchTerm } }
					{ total_amount: { _eq: $amount } }
					{ open_amount: { _eq: $amount } }
					{ recipient_by_reference: { bank_accounts: { account_number: { _ilike: $searchTerm } } } }
					{ recipient_by_reference: { name: { _ilike: $searchTerm } } }
					{ recipient_by_reference: { account_id: { _ilike: $searchTerm } } }
				]
			}
		) {
			reference
			recipient
			recipient_by_reference {
				reference
				name
				account_id
				bank_accounts {
					account_number
				}
			}
			processing_due_date
			invoice_number
			status
			payment_reference
			open_amount
			total_amount
		}
	}
`;

export const _ACTIONS_BY_INVOICE = gql`
	query gqlInvoices_actionsByInvoice($invoice: uuid!) {
		total: risolto_action_aggregate(where: { action_invoices: { invoice: { _eq: $invoice } } }) {
			aggregate {
				count
			}
		}
		actions: risolto_action(where: { action_invoices: { invoice: { _eq: $invoice } } }) {
			action_invoices {
				action
				action_by_reference {
					status
					channel
					source
					recipient
					participant
					metadata
				}
				invoice
				invoice_by_reference {
					reference
					invoice_number
					processing_due_date
				}
			}
		}
	}
`;
